<template lang="html">
  <div class="bg-gray" >
    <transition name="right">
      <div class="web-wepper" v-if="product">
        <p class="web-info-tit" @click="goHome">首页 - 产品详情</p>

        <div class="web-info-head">
          <div class="banner">
            <img :src="product.logo" alt="">
          </div>
          <div class="content">
            <p class="title">{{product.title}}</p>
            <p class="introduce">{{product.subtitle}}</p>
            <div class="information-info">
              <div class="">
                <p class="num">{{product.view_num}}</p>
                <p class="tit">浏览</p>
              </div>
              <div class="">
                <p class="num">{{product.follow_num}}</p>
                <p class="tit">关注支持</p>
              </div>
              <div class="">
                <p class="num">{{product.sold_num}}
                  <!-- <i>万</i> -->
                </p>
                <p class="tit">已预定</p>
              </div>
            </div>
            <div class="titles" v-show="product.type * 1 === 0">
              今日线上预定，{{filDate(product.estimated_at)}}即可提车
            </div>

            <div class="min-title" v-show="product.type * 1 === 0">
              常规线下预定,预计提车时间：{{filDate(product.underline_estimated_at)}}
            </div>

            <div class="special-max" v-show="product.type * 1 === 1">
              <div class="old-price">
                <p>特价: <span>{{filPrice(product.special_price)}}</span> <i v-show="product.special_price > 10000">万</i></p>
                <p>原价: {{filPrice(product.original_price)}} <i v-show="product.original_price > 10000">万</i></p>
              </div>

              <div class="car-num">
                现仅剩 <span>{{product.stock_surplus}}</span> 辆
              </div>
            </div>

            <div class="info-footer">
              <button type="button" name="button" @click="onFollowClick" class="one" :class="{'active': product.is_follow * 1 === 1}"><i></i> <span>{{product.is_follow * 1 === 1 ? '已关注' : '关注支持'}}</span></button>
              <button type="button" name="button"  class="two" @click.stop="shareShow = true"><i></i><span>分享</span></button>
              <button type="button" name="button" @click="onCommentClick" class="three"><i></i><span>评论</span></button>
              <button type="button" name="button" @click="onBynowClick" class="submit" v-if="product.is_sell_out === 0">￥{{filPrice(product.reserve_price)}} 立即预定</button>
              <button type="button" name="button" class="submit end" v-if="product.is_sell_out === 1">预定已结束</button>
            </div>
          </div>
        </div>

        <div class="web-info-body">
          <div class="content">
            <h3>产品介绍</h3>
            <div class="content-information" v-html="product.content">
              {{product.content}}
            </div>
            <h3>预定流程</h3>
            <div class="content-information" v-html="product.booking_process">
              {{product.booking_process}}
            </div>
            <h3>获得服务</h3>
            <div class="content-information" v-html="product.get_service">
              {{product.get_service}}
            </div>

            <div class="lines"></div>
            <!-- 评论 -->
            <div  v-if="commentObj" id='commentBlock' class="conmmet-body">

              <h3>评论</h3>
              <div class="common-submit">
                <form class="" @submit.prevent="onCommentSubmit">
                  <div class="">
                    <textarea name="name" v-model="commentForm.content" :placeholder="placeholder || '留下你的真知灼见…'"></textarea>
                  </div>
                  <span class="num">{{commentForm.content.length}}/500</span>
                  <button type="submit" name="button" class="btn">发送</button>
                </form>
              </div>
              <div v-for="comment in commentObj.list" :key="comment.id" class="conmmet-max">
                <div class="avatar">
                  <img :src="comment.user.avatar" alt="">
                </div>
                <div class="content">
                  <p class="user">{{comment.user.nickname}} <span class="tag" v-show="comment.is_buyer === 1">买家</span></p>
                  <p class="text">{{comment.content}}</p>
                  <p class="bottom">
                    <span class="time">{{comment.created_at}}</span>
                    <span class="praise" @click="pariseClick(comment)" :class="{'active': comment.is_praise === 1}">{{comment.praise_num}}<i></i></span>
                    <span class="replay" @click="onCommentClick(comment)">{{comment.reply_num}}<i></i></span>
                  </p>
                  <div class="reply-list" v-if="comment.reply.list.length > 0">
                    <div class="reply-max" v-for="reply in comment.reply.list" :key="reply.id">
                      <p><span>{{reply.user.nickname}}：</span> {{reply.content}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div @click="openProductDetail(item)" class="web-info-rv" v-for="(item, index) in product.recommend" :key="index">
            <div class="banner">
              <img :src="item.logo" alt="">
            </div>
            <div class="title">
              {{item.title}}
            </div>
            <div class="sub-title">
              {{item.subtitle}}
            </div>
          </div>
        </div>
        <!-- <div class="tel-btn">
          <button type="button" name="button" @click="telBtn">
            <i class="icon"></i>
            拨打专属客服热线
          </button>
        </div> -->

        <!-- <div class="relevance-rv" v-if="product.rv_info">
          <div class="img">
            <img :src="product.rv_info.brand_logo" alt="">
          </div>
          <div class="content">
            <p class="name">{{product.rv_info.name}}</p>
            <p class="price">指导价:{{product.rv_info.price}}</p>
            <p class="type">{{product.rv_info.chassis_name}}/<span v-show="product.rv_info.fuel_name">{{product.rv_info.fuel_name}}/</span>{{product.rv_info.transmission_case_type}}/{{product.rv_info.people_num}}人/{{product.rv_info.level_name}}</p>
          </div>
        </div> -->

      </div>

    </transition>

     <!-- 购物车 -->
     <popup v-model="cartModalVisible" @on-hide="log('hide')" @on-show="log('show')">
      </popup>
      <div class="pay-web-max" v-if="cartModalVisible">
        <i class="close" @click="cartModalVisible = false"></i>
        <h3>订购商品</h3>
        <div class="cart-info" v-if="cart.product">
          <div class="img">
            <img :src="cart.product.banner" alt="">
          </div>
          <div class="content">
            <div class="title">
              {{cart.product.title}}
            </div>
            <p class="tit" v-if="cart.product">{{cart.product.subtitle}}</p>
          </div>
        </div>
        <div class="num-web-max">
          <span>数量</span>
          <div class="num-max">
            <div class="btn" @click="cart.minus()">-</div>
            <div class="num">{{cart.num}}</div>
            <div class="btn" @click="cart.plus()">+</div>
          </div>
        </div>
        <div class="price">
          需支付预定金: <span>￥{{cart.total_price}}</span>
        </div>

         <button type="button" name="button" @click="onCartSubmit">立即下单</button>
      </div>

    <!-- 评论表单 -->
    <!-- <div class="" v-show="commentFormVisible">
      <form class="" @submit.prevent="onCommentSubmit">
        <div class="">
          <textarea name="name" v-model="commentForm.content"></textarea>
        </div>
        <div class="">
          <button type="submit" name="button">提交</button>
        </div>
      </form>
    </div> -->
    <toast v-model="showMsg" type="text" :time="800" is-show-mask :position="'middle'">{{msgTxt}}</toast>
    <popup v-model="shareShow" @on-hide="log('hide')" @on-show="log('show')" :position="'center'" class="bg-none">
    </popup>
    <img :src="product.share_web" alt="" v-if="shareShow" class="pc-img" style="width:500px;">
  </div>
</template>

<script>
import CartFactory from '../../factory/CartFactory'
import ProductFactory from '../../factory/ProductFactory'
import ProductService from '../../service/ProductService'
import AccountFactory from '../../account/AccountFactory'
import CommentForm from '../../form/CommentForm'
import Popup from 'vux/src/components/popup'
import Toast from 'vux/src/components/toast'

export default {
  components: {
    Popup,
    Toast
  },
  data: () => ({
    cartModalVisible: false,
    commentFormVisible: false,
    commentForm: new CommentForm(),
    product: null,
    commentObj: null,
    msgTxt: '',
    showMsg: false,
    placeholder: '',
    shareShow: false,
    cart: CartFactory.create() // new Cart 将会重置当前系统的购物车
  }),
  methods: {
    async getDetail () {
      const { id } = this.$route.params
      const product = await ProductService.getDetail({ id })
      if (product) {
        this.product = product
        this.commentObj = product.comment_list
      }
    },
    // 点击关注按钮
    onFollowClick () {
      // 登录状态检查
      const auth = AccountFactory.isLoggedin()
      if (auth) {
        // 交给工厂处理
        this.product = ProductFactory.doFollow(this.product)
      } else {
        AccountFactory.tryLogin()
      }
    },
    // 点击分享按钮
    onShareClick () {
      // todo
    },
    // 点击点赞按钮
    pariseClick (item) {
      const auth = AccountFactory.isLoggedin()
      if (auth) {
        const query = {
          product_id: this.product.id,
          id: item.id,
          status: item.is_praise === 1 ? 0 : 1
        }
        ProductService.doPraise(query).then(res => {
          if (res.data.code === 1) {
            if (item.is_praise === 1) {
              this.msgTxt = '点赞已取消'
              item.praise_num--
              item.is_praise = 0
            } else {
              this.msgTxt = '点赞成功'
              item.praise_num++
              item.is_praise = 1
            }
            this.showMsg = true
          }
        })
      } else {
        AccountFactory.tryLogin()
      }
    },
    // 点击评论按钮
    onCommentClick (item) {
      // 滚动到评论区
      this.scroll2Comment()
      // 登录状态检查
      const auth = AccountFactory.isLoggedin()
      if (auth) {
        if (item && item.user) {
          this.commentForm.pid = item.id
          this.placeholder = '回复:' + item.user.nickname
        }
        this.toggleCommentFormShow()
      } else {
        AccountFactory.tryLogin()
      }
    },
    // 滚动到评论区
    scroll2Comment () {
      // todo scroll to comment block
      document.getElementById('commentBlock').scrollIntoView()
    },
    // 评论输入区显示开关
    toggleCommentFormShow () {
      this.commentFormVisible = !this.commentFormVisible
      if (!this.commentFormVisible) {
        this.placeholder = ''
      }
    },
    // 提交评论
    async onCommentSubmit (e) {
      e.preventDefault()
      // 登录状态检查
      const auth = AccountFactory.isLoggedin()
      if (auth) {
        // 交给工厂处理
        const commentObj = await ProductFactory.doComment({
          product: this.product,
          commentObj: this.commentObj,
          commentForm: this.commentForm
        })
        if (commentObj) {
          this.commentObj = commentObj
          this.commentForm = new CommentForm()
        }
        this.toggleCommentFormShow()
      } else {
        AccountFactory.tryLogin()
      }
    },
    // 点击预定按钮
    onBynowClick () {
      // 登录状态检查
      const auth = AccountFactory.isLoggedin()
      if (auth) {
        // 交给工厂处理
        this.cartModalVisible = !this.cartModalVisible
        this.cart = CartFactory.create({ product: this.product })
        this.cart.plus()
      } else {
        AccountFactory.tryLogin()
      }
    },
    onCartSubmit () {
      const { cart } = this
      CartFactory.save({ cart })
      document.body.style.overflow = 'auto'
      this.$router.push({ name: 'CartHome' })
    },
    filDate (val) {
      if (val) {
        const date = val.split('-')
        return date[0] + '年' + date[1] + '月' + date[2] + '日'
      }
    },
    telBtn () {
      // console.log(22)
    },
    filPrice (val) {
      if (val > 10000) {
        return (val / 10000).toFixed(2)
      } else {
        return val * 1
      }
    },
    goHome () {
      this.$router.replace({ name: 'Home' })
    },
    openProductDetail (item = {}) {
      const { id } = item
      this.$router.push({ name: 'ProductDetail', params: { id } })
    },
    log (val) {
      if (val === 'show') {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    }
  },
  created () {
    this.getDetail()
  },
  watch: {
    $route (to, from) {
      this.product = null
      this.getDetail()
    }
  }
}
</script>

<style lang="css" scoped>
</style>
